export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESET_PASSWORD = "AUTH_RESET_PASSWORD";
export const TWO_FACTOR_UUID_REQUESTED = "TWO_FACTOR_UUID_REQUESTED";
export const CANCEL_TWO_FACTOR_VALIDATION = "CANCEL_TWO_FACTOR_VALIDATION";

export const USER_REQUESTED = "USER_REQUESTED";
export const USER_LOADED = "USER_LOADED";
export const FULLFILL_USER_SETTINGS = "FULLFILL_USER_SETTINGS";

export const SET_CURRENT_MODULE = "SET_CURRENT_MODULE";
export const SET_CURRENT_COMPANY_SESSION = "SET_CURRENT_COMPANY_SESSION";

export const REQUEST_TIMEZONE_LIST = "REQUEST_TIMEZONE_LIST";
export const TIMEZONES_FETCH_SUCCEEDED = "TIMEZONES_FETCH_SUCCEEDED";
